module.exports = __webpack_public_path__ + "img/rutx11.c6947fd.gif";